import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { AuthStore } from '../../core/stores/auth.store';

@Component({
  selector: 'app-forbidden',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './forbidden.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenComponent {
  private readonly authService = inject(AuthService);
  private readonly authStore = inject(AuthStore);

  public readonly user = this.authStore.user;

  public onLogout(): void {
    this.authService.logout();
  }
}
